<div class="d-flex w-100 gap-2">
  <app-datepicker #DatePicker  [now]="true"  (dateSelected)="receiveDate($event)" class="d-flex w-100" style="max-width: 500px"></app-datepicker>
  <input [class.d-none]="disableTime" nbInput status="basic" [formControl]="timePickerFormControl" [nbTimepicker]="timepicker" type="text" />
  <nb-timepicker [class.d-none]="disableTime" [step]="step" timeFormat="HH:mm"  applyButtonText="انتخاب" (onSelectTime)="onPickTime($event)" #timepicker></nb-timepicker>
</div>
